<div class="app-modal-title">Integrator</div>
<div class="app-modal-content">
	<div class="table-container">
		<app-common-datagrid
			#integratorTable
			[columns]="columns"
			[rows]="currentIntegrators"
			[rowH]="40"
			[columnMode]="'standard'"
			[selectionType]="undefined"
			[totalNum]="currentIntegrators.length"
			[isPaging]="false"
		></app-common-datagrid>
	</div>
	<div *ngIf="currentIntegrators.length < integrators.length">
		<select name="select-integrator" [(ngModel)]="selectedIntegrator" (ngModelChange)="changeIntegrator()">
			<option *ngFor="let integrator of integrators" [hidden]="integrator.isSelected" [ngValue]="integrator" >{{integrator.nameShort}}</option>
		</select>
		<i class="glyphicons glyphicons-plus-sign" title="Invite this integrator" [ngClass]="{'disabled': !selectedIntegrator}" (click)="addIntegrator()"></i>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<!-- <button class="button-general" md-raised-button (click)="cancel()">Cancel</button> -->
		<button class="button-general" md-raised-button (click)="confirm()">Ok</button>
	</div>
</div>

<ng-template #operationsTempl let-row="row" let-column="column" let-value="value">
	<div>
		<i class="glyphicons glyphicons-minus-sign" title="Remove the integrator" (click)="removeIntegrator(row)"></i>
	</div>
</ng-template>